var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSharing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 155 155",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    className: "style-scope yt-icon",
    style: {
      pointerEvents: "none",
      display: "block",
      width: "100%",
      height: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    viewBox: "0 0 155 155",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 34.3C91 27 128.7 18.8 141.7 52.6c7.3 19 9.3 40.2 2.8 56.4 0 0-16.4 15-33 18-33.9 6.4-51.7 9.2-68.7 8.2-10.6-.7-28.8-10.6-28.8-10.6a45.7 45.7 0 0 1-3.7-25C12.8 72 24.1 53 72.1 34.2",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5 69.6c0-5.6 4.2-9.3 9.4-9.3 5.7 0 9.5 4 9.4 9.3a9.3 9.3 0 0 1-9.4 9.4c-5.4.1-9.4-3.8-9.4-9.4",
    fill: "red",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.4 59.7c-4 0-6.5-3-6.5-6.6 0-4 2.9-6.7 6.5-6.6 3.7.1 6.5 2.6 6.6 6.6.1 3.8-2.6 6.6-6.6 6.6",
    fill: "#00D4B5",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6 62.2c-2.8 0-4.5-2-4.5-4.6 0-2.7 2-4.6 4.5-4.5 2.5 0 4.5 1.8 4.5 4.5.1 2.7-1.8 4.6-4.5 4.6",
    fill: "#FF76DA",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 47.3c-1.8 0-3-1.4-3-3.1 0-1.9 1.3-3.2 3-3.1a3 3 0 0 1 3.1 3c0 1.9-1.2 3.2-3 3.2",
    fill: "#EEE",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4 14c-2.9.1-2.7 8.7-4.2 9-1.5.2-9.4-3-10.4-.6-1 2.2 6.4 5.5 6.5 6.9 0 1.3-7.8 5.5-6.8 7.7 1 2.3 9.5-2 10.6-1.2 1 .9 2.1 8.8 4.3 8.8 2.1 0 3.6-8 5.4-8.3 1.8-.4 6.5 3.2 8.5 1.2s-5.1-5.8-4.7-7.2c.5-1.4 7.6-5.5 6.6-8-1-2.4-10.6 2.1-11.5.4-1-1.8-1.7-8.8-4.3-8.7",
    fill: "#FF76DA",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2 58a1 1 0 0 1-1-.7l-4.6-15.2a1 1 0 1 1 2-.6l4.6 15.2a1 1 0 0 1-1 1.3M121.8 64.6a1 1 0 0 1-.4-2l12.8-5.9a1 1 0 1 1 .8 1.8l-12.8 6a1 1 0 0 1-.4.1",
    fill: "#00D4B5",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13 71)",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "#fff",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.8.3h130.6V70H.8z",
    className: "style-scope yt-icon"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.7 69.7c17 1 39 0 72.9-6.3A40.2 40.2 0 0 0 131.4 38c-3.1-7.7-6.5-14.7-9.9-21.7-5-10.3-9.8-15.8-12.7-15-2 .5-2.3 2.2-1.8 6-1.5-3.2-5-7.6-7.1-7.1-2 .5-2.7 2.3-1.6 7C96.1 3 93.1.9 91.1 1.7c-1.9.9-1.8 4.2-.7 7.4-1.7-2.5-4.8-4.7-6.6-3.7-1.8 1-2.7 3.6 0 10.7 2.7 7.3 9.1 17.5 11 22.8 1.8 5.3-6.6 8.2-13.6 2.2-7.1-6-14.2-14-31.8-12.4C33.2 30.1 9.2 39.5.8 53.5a29.6 29.6 0 0 0 26 16.2",
    fill: "#FFF",
    mask: "url(#account_sharing__b)",
    className: "style-scope yt-icon"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.8 128.1c-3.3 0-5.4-2.4-5.4-5.5 0-3.4 2.4-5.7 5.4-5.6 3.1.1 5.5 2.2 5.6 5.6 0 3.2-2.2 5.5-5.6 5.5",
    fill: "red",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 111.2c-2 1-5 7.7-2.6 11.1 2.4 3.5 6.3-2.8 6.3-2.8s6.7 1.2 6.7-1.8-7.2-8.1-10.4-6.5M26.6 41c-12.2 4.7-31.8 18-20 47.7 5.8 14.2 14 20.1 22.4 21.9 0 0 17.2-3.6 23.5-6.1 4.3-1.8 15.2-5 15.2-5 7.9-6.4 13.2-17.4 6.1-38.5-9.2-27.8-32.2-25.7-47.2-20",
    fill: "#FF76DA",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 52.4C18.6 57 8.9 67.2 16 84.4 21.2 97 29.2 96 31.4 106c.3 1.5-.1 2.9-2.4 4.5l37.6-11.1c-7-3.8 7.6-12-1.8-33.3a35 35 0 0 0-10.5-14.6c-6.7-5-14.3-3-23.8.8",
    fill: "#00D4B5",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 107c4.2-1.8 9.3-4 13.7-7.5a85 85 0 0 0-38.7 11 44 44 0 0 0 25-3.5",
    fill: "#00D4B5",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 85.1c-3.7-4-12.4-9.6-10.7-15 2-6 11.4-6.1 24.1-11.5 7-3 10.9-5.4 13-7-6.8-5-14.8-4-24.3-.3-11.9 4.7-21.9 16-14.5 33 5.4 12.9 16.3 17 15.9 23.2 5.6-9.4-.3-18.7-3.6-22.4",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7 70.2c-.7-4-5.3-3.8-5.3-3.8l-.7.3c-2.8 1.5-8.2 6-7 9.5.8 2.7 4.7 2.7 7.9 1.8.8-.3 5.7-4.3 5.1-7.8",
    fill: "#F7F7F7",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 70c-.6-4-4.7-4.7-7.6-3.6-.7 4.2-.4 8.5.2 11.5.8-.2 1.7-.5 2.4-1 3.2-1.6 5.7-3.4 5-7",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3 58.4c-2.8 1.5-8.2 6-7 9.5.8 2.7 4.7 2.7 7.9 1.8.8-.3.8-12-.2-11.6l-.7.3",
    fill: "#F7F7F7",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 58.1c-.7 4.2-.4 8.5.2 11.6l2.4-1c2-1 3.8-2.2 4.6-3.8a48.4 48.4 0 0 0-4.1-7.2c-1-.1-2.1 0-3 .4",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.7 98H104a.8.8 0 0 1 0-1.6h32.7a.8.8 0 0 1 0 1.5M138.4 102.1h-32.7a.8.8 0 0 1 0-1.5h32.7a.8.8 0 0 1 0 1.5M96.8 118.3c-.4.2-.5.6-.3 1 2.9 5.4 5.4 11.7 7.1 16.6l1.5-.2c-1.7-5-4.3-11.5-7.3-17a.8.8 0 0 0-1-.4M101.2 117.6c-.4.1-.5.6-.3 1 2.8 5.4 5.3 11.7 7 16.6l1.6-.3c-1.8-5-4.3-11.5-7.3-17a.8.8 0 0 0-1-.3M23.4 121c-.3.2-.4.7-.1 1a62 62 0 0 1 7.5 17l1.8.5c-1.8-5.7-4.7-14-8.1-18.4a.8.8 0 0 0-1-.1M27.3 117.8c-.4.3-.5.7-.2 1a80.3 80.3 0 0 1 9 21.4l1.6.3c-2-8-5.8-17-9.4-22.5a.7.7 0 0 0-1-.2",
    fill: "#00D4B5",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1 87c-.5 0-1 0-1.6-.2-2.3-.9-4.2-3.5-5.2-7.2a.7.7 0 1 1 1.5-.4c.8 3.2 2.4 5.5 4.2 6.2 1 .4 2 .2 3-.5 3-2-.3-8.1-.3-8.2A.8.8 0 0 1 55 76c.2.3 4 7.3-.1 10.2a5 5 0 0 1-2.8.9",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharing);
export default __webpack_public_path__ + "static/media/sharing.3169ef45d6a31db25d5d4a7fbe298080.svg";
export { ForwardRef as ReactComponent };